export class MediaFilterModel {
  public id: number;
  public label: string;
  public isGroup: boolean;
  public idParent: number;
  public listIdParent: number[];
  public highlight: boolean;
  public disabled: boolean;
  public description: string;
}
